var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fund!==null)?_c('BaseInfoButton',{attrs:{"identifier":_vm.fund.id,"viewmodel":_vm.fund,"extraClasses":['fund']},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var url = ref.url;
return [_c('a',{attrs:{"href":url,"target":"_blank"}},[_vm._v("fund")])]}}],null,false,3997091700)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }